import React from 'react';
import {injectStripe} from 'react-stripe-elements';

import CardSection from './CardSection';
import loadingImg from "../../../../../assets/img/loading.gif";

class CheckoutForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cardButtonDisabled : false,
            hidePaymentProgress : true
        }
    }
    handleSubmit = (ev) => {
        console.log("STRIPEEEEE ====>", this.props.paymentClient);
        // this.setState({
        //     cardButtonDisabled : true,
        //     hidePaymentProgress : false
        // });
        // We don't want to let default form submission happen here, which would refresh the page.
        ev.preventDefault();


        // See our confirmCardPayment documentation for more:
        // https://stripe.com/docs/stripe-js/reference#stripe-confirm-card-payment
        // this.props.stripe
        //     .confirmCardPayment(this.props.paymentClient, {
        //     payment_method: {
        //         card: this.props.elements.getElement('card'),
        //         billing_details: {
        //             name: this.props.userDetails.name,
        //         }
        //     }
        // })
        //     .then((result) => {
        //     if(result.paymentIntent !== undefined){
        //         this.setState({
        //             hidePaymentProgress : true
        //         });
        //         this.props.openMessageDialog("支払いが成功しました","message-success", result.paymentIntent.id);
        //     }else {
        //         this.setState({
        //             hidePaymentProgress : true
        //         });
        //         // alert(result.error.message);
        //         this.props.openMessageDialog(result.error.message, "message-error", "0");
        //     }
        // });

        console.log("STRIPEEEEE ====>", this.props.stripe);
    };

    render() {

        let cartInfo = {
            userId: this.props.userId,
            cartItemIds: this.props.cartItemIds,
            paymentId: this.props.paymentIntent,
            total: this.props.orderTotal,
            discount: this.props.discount,
            paymentMethod : "CARD"
        };

        localStorage.setItem("stp", JSON.stringify(cartInfo));

        console.log("LOCALLLLLLLLLLLLLLLLLLLLLLLL ====> ", JSON.parse(localStorage.getItem("stp")));

        this.props.stripe.redirectToCheckout({
            // Make the id field from the Checkout Session creation API response
            // available to this file, so you can provide it as parameter here
            // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
            sessionId: this.props.paymentClient,


        }).then(function (result) {
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer
            // using `result.error.message`.
        });
        return (
           <div>
           <h4>お待ちください ...</h4>
           </div>
        );
    }
}

export default injectStripe(CheckoutForm);



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderConfirmationBottom/StripeComponents/CheckoutForm.js